<template>
  <div style="width: 100%; margin-top: 16px">
    <div v-for="(item, index) in optionsList" :key="index" class="option-item" :class="{
      isActive: selectData.includes(item.title) && !readonly,
      isTrue:
        answer.answerResults &&
        answer.answerResults.includes(item.title) &&
        answer.answerSituation === '1' &&
        readonly,
      isFalse:
        answer.answerResults &&
        answer.answerResults.includes(item.title) &&
        answer.answerSituation === '0' &&
        readonly,
    }" @click.stop="select(item.title, $event)">
      <div class="questionSeq" v-if="styleType == 1">
        <img style="margin-right: 10px" v-if="isAnswer &&
          selectData.length &&
          selectData.includes(item.title) &&
          standardAnswer.some((i) => i.title === item.title)
        " src="../../../assets/images/new-right.png" alt="" />
        <img style="margin-right: 10px" v-if="isAnswer &&
          selectData.length &&
          selectData.includes(item.title) &&
          standardAnswer.every((i) => i.title !== item.title)
        " src="../../../assets/images/new-error.png" alt="" />
        <el-checkbox v-if="!readonly && !isAnswer" @click.native="
          SkipProgress($event, item.title, selectData.includes(item.title))
          " :value="selectData.includes(item.title)">{{ "" }}</el-checkbox>
      </div>
      <div v-if="showTitle" style="text-align: right;" class="questionSeq">
        {{ serialNumber[index] }}
      </div>
      <bc-view-common flex-box="1" :border="false" :content="item.content" :fileInfo="item.fileInfo"></bc-view-common>
    </div>
  </div>
</template>

<script>
export default {
  name: "bc-view-option-checkbox",
  props: {
    option: {
      type: [String, Array],
      default: "",
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    answer: {
      type: Object,
      default: () => { },
    },
    typeOk: {
      type: String,
      default: "false",
    },
    isAnswerx: {
      type: Boolean,
      default: false,
    },
    isAnswerResults: {
      type: [String, Object],
      default: "",
    },
    styleType: {
      type: [String, Number],
      default: "1",
    },
  },
  data() {
    return {
      optionsList: [],
      selectData: [],
      isAnswer: false,
      serialNumber: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
    };
  },
  watch: {
    option: {
      handler(val) {
        try {
          if (Array.isArray(val)) {
            this.optionsList = val.map(function (item) {
              return typeof item == "object" ? item : JSON.parse(item);
            });
          } else {
            this.optionsList = JSON.parse(val);
          }
        } catch (err) {
          this.optionsList = [];
        }
      },
      immediate: true,
    },

    isAnswerResults: {
      handler(val) {
        if (typeof val == "object") {
          this.selectData = val.value.split(",");
        } else {
          this.selectData = val.split(",");
        }
      },
      immediate: true,
    },
  },
  methods: {
    select(item, e) {
      if (e.target.tagName === "INPUT") {
        e.stopPropagation();
        return;
      }
      if (this.typeOk == "false") {
        if (this.isAnswerx) return;
      }
      if (this.readonly) return;
      let index = this.selectData.findIndex((i) => i === item);
      if (index !== -1) {
        this.selectData.splice(index, 1);
      } else {
        this.selectData.push(item);
      }
      this.selectData.sort((a, b) => a.charCodeAt() - b.charCodeAt());
      var r = this.selectData.filter(function (s) {
        return s && s.trim();
      });
      this.$emit("change", r.join(","));

    },
    SkipProgress(e, title, val) {
      if (e.target.targetName === "INPUT") {
        e.stopPropagation();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.option-item+.option-item {
  margin-top: 16px;
}

.option-item {
  // background: #fbfbfb;
  border-radius: 6px;
  padding-left: 16px;
  cursor: pointer;
  transition: all ease 0.3s;
  border: 1px solid #fbfbfb;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 5px;

  &.isActive {
    //background: #ccc;
    border-color: #2e9adb;
  }

  .questionSeq {
    padding: 8px 0;
    display: flex;
    align-items: center;
  }

  &.isTrue {
    border: 1px solid #70b603;

    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
      border-color: #70b603;
      background: #70b603;
    }
  }

  &.isFalse {
    border: 1px solid #d9001b;

    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
      border-color: #d9001b;
      background: #d9001b;
    }
  }

  &:hover {
    // background: #ddd;
    border-color: #C5E3F8;
    transform: scale(1.003);
    transition: all 0.5s;
  }

  ::v-deep .content {
    cursor: pointer;
  }

  ::v-deep .stem-content {
    &.no-border {
      padding: 8px 14px !important;
      cursor: pointer;
    }
  }
}
</style>
